import startsWith from 'lodash/startsWith';

import nls from './nls/PayrollReview';
import { createTranslator } from '~/lib/nls-helper';

import { isMobile } from '~/genericFunctions';

export const isButtonVisible = (ismobile) => !isMobile(ismobile);

export const NLS = createTranslator(nls);

export const setPageTitle = (title) => {
  document.title = title;
};

export const getHeaderKey = (offerId) => {
  if (startsWith(offerId, 'Simple_Nom') || ['TopUp_AN_MB', 'TopUp_AN_Mob', 'Simple_MenoresAN_Mob', 'Pasivos_AN_Mob', 'TopUp_KR_PIB_AN', 'TopUp_KR_MOB_AN'].includes(offerId))
    return 'HSBC Payroll Loan';
  else if (startsWith(offerId, 'Simple_CP') || ['Nva_TopUp_CP', 'TopUp_CP_MB', 'TopUp_CP_Mob', 'Simple_MenoresCP_Mob', 'Pasivos_CP_Mob', 'TopUp_KR_PIB_CP', 'TopUp_KR_MOB_CP'].includes(offerId))
    return 'HSBC Personal Loan';
  else {
    return 'HSBC Personal Loan or HSBC Payroll Loan';
  }
};
